import {
  GET_DEALER_LIST_REQUEST,
  GET_DEALER_LIST_SUCCESS,
  GET_DEALER_LIST_FAILURE,
  DEALER_SEARCH_REQUEST,
  DEALER_SEARCH_SUCCESS,
  DEALER_SEARCH_FAILURE,
  RESET_SNACKBAR,
  ADD_DEALER_REQUEST,
  ADD_DEALER_FAILURE,
  ADD_DEALER_SUCCESS,
  RESET_DEALER_SEARCH,
  UPDATE_DEALER_STATUS_REQUEST,
  UPDATE_DEALER_STATUS_SUCCESS,
  UPDATE_DEALER_STATUS_FAILURE,
  DEALER_COUNTRY_LIST_SUCCESS,
  DEALER_COUNTRY_LIST_REQUEST,
  DEALER_COUNTRY_LIST_FAILURE
} from './constants';

const initialState = {
  dealerList: { dealers: [] },
  dealerSearch: [],
  searchLoader: false,
  loading: false,
  message: '',
  messageType: '',
  countryList: []
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_DEALER_LIST_REQUEST:
    case UPDATE_DEALER_STATUS_REQUEST:
      return { ...state, loading: true };
    case GET_DEALER_LIST_SUCCESS:
      return { ...state, dealerList: action.dealerList.data, loading: false };
    case GET_DEALER_LIST_FAILURE:
      return { ...state, dealerList: {}, message: action.error.message, loading: false };
    case DEALER_SEARCH_REQUEST:
      return { ...state, searchLoader: true };
    case DEALER_SEARCH_SUCCESS:
      return {
        ...state,
        dealerSearch: action.dealerSearch.data,
        message: action.dealerSearch.message,
        messageType: 'success',
        searchLoader: false
      };
    case DEALER_SEARCH_FAILURE:
      return { ...state, dealerSearch: [], message: action.error.message, messageType: 'error', searchLoader: false };
    case ADD_DEALER_REQUEST:
      return { ...state };
    case ADD_DEALER_SUCCESS:
      return {
        ...state,
        dealerSearch: [],
        messageType: 'success',
        message: action.dealer.message
      };
    case ADD_DEALER_FAILURE:
      return { ...state, dealerSearch: [], messageType: 'error', message: action.error.message };
    case UPDATE_DEALER_STATUS_SUCCESS:
      const dealers = state.dealerList.dealers.map(e => {
        if (action.status.authorized_dealer_id === e.authorized_dealer_id) {
          e.status = parseInt(action.status.status.toString());
        }
        return e;
      });
      return {
        ...state,
        dealerList: { ...state.dealerList, dealers },
        loading: false,
        messageType: 'success',
        message: action.message
      };
    case UPDATE_DEALER_STATUS_FAILURE:
      return { ...state, message: action.error.message, messageType: 'error', loading: false };
    case RESET_SNACKBAR:
      return { ...state, messageType: '' };
    case RESET_DEALER_SEARCH:
      return { ...state, dealerSearch: [] };
    case DEALER_COUNTRY_LIST_REQUEST:
      return { ...state };
    case DEALER_COUNTRY_LIST_SUCCESS:
      const { countryList } = action;
      return {
        ...state,
        countryList: Object.keys(countryList).map(e => ({ name: countryList[e], value: e }))
      };
    case DEALER_COUNTRY_LIST_FAILURE:
      return { ...state, messageType: 'error', message: action.error.message };
    default:
      return state;
  }
}

export default reducer;
